import { normalizeImageUrl } from './imageUtils';

/**
 * Utility to dynamically update document title & Open Graph (og:image, og:title, og:description) meta tags
 * when navigating to post/event/service detail pages.
 */
export const updateMetaTags = ({ title, description, image, url }) => {
    if (typeof document === 'undefined') return;

    // 1. Update browser title
    if (title) {
        document.title = `${title} | Trung Anh Garage`;
    }

    // Helper to set or create head meta tags
    const setMetaTag = (selector, attrName, attrVal, contentVal) => {
        if (!contentVal) return;
        let element = document.querySelector(selector);
        if (!element) {
            element = document.createElement('meta');
            element.setAttribute(attrName, attrVal);
            document.head.appendChild(element);
        }
        element.setAttribute('content', contentVal);
    };

    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

    // Formulate absolute image URL (Zalo, Facebook, Messenger require absolute http/https URLs)
    let fullImageUrl = '';
    if (image) {
        const normalized = normalizeImageUrl(image);
        if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
            fullImageUrl = normalized;
        } else if (typeof window !== 'undefined') {
            const origin = window.location.origin;
            const path = normalized.startsWith('/') ? normalized : `/${normalized}`;
            fullImageUrl = `${origin}${path}`;
        }
    }

    // 2. Open Graph meta tags
    setMetaTag('meta[property="og:title"]', 'property', 'og:title', title);
    setMetaTag('meta[property="og:description"]', 'property', 'og:description', description || title);
    setMetaTag('meta[property="og:url"]', 'property', 'og:url', currentUrl);
    if (fullImageUrl) {
        setMetaTag('meta[property="og:image"]', 'property', 'og:image', fullImageUrl);
        setMetaTag('meta[property="og:image:secure_url"]', 'property', 'og:image:secure_url', fullImageUrl);
    }

    // 3. Twitter Card meta tags
    setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', title);
    setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description || title);
    if (fullImageUrl) {
        setMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', fullImageUrl);
    }
};
